import { useTheme } from "@emotion/react";
import React from "react";

import { stripSupportTicketMessageMetadata } from "./stripSupportTicketMessageMetadata";

const looksLikeHtml = (body: string): boolean => {
  const trimmed = body.trim();
  return trimmed.startsWith("<") || /<\s*html[\s>]/i.test(trimmed) || /<\s*div[\s>]/i.test(trimmed);
};

const stripQuotedContent = (body: string): string => {
  const lines = body.split("\n");
  let cutIndex = lines.length;

  for (let i = 0; i < lines.length; i++) {
    if (!lines[i].startsWith(">")) continue;

    let j = i - 1;
    while (j >= 0 && lines[j].trim() === "") j--;

    if (j < 0) {
      cutIndex = 0;
      break;
    }

    if (lines[j].trimEnd().endsWith(":")) {
      let start = j;
      while (start > 0 && lines[start - 1].trim() !== "") start--;
      cutIndex = start;
    } else {
      cutIndex = j + 1;
    }
    break;
  }

  return lines.slice(0, cutIndex).join("\n").trimEnd();
};

type Props = {
  body: string;
  className?: string;
};

export const SupportTicketMessageBody: React.FC<Props> = ({ body, className }) => {
  const theme = useTheme();
  if (!body) return null;
  if (looksLikeHtml(body)) {
    return (
      <iframe
        title="Treść wiadomości"
        sandbox="allow-same-origin"
        srcDoc={`<!DOCTYPE html><html><head><meta charset="utf-8"><base target="_blank" rel="noopener"></head><body style="margin:0;padding:8px;font-family:sans-serif;font-size:14px;">${body}</body></html>`}
        css={{
          width: "100%",
          minHeight: 120,
          maxHeight: 480,
          border: `1px solid ${theme.colors.border}`,
          borderRadius: theme.extraSmallBorderRadius,
          overflow: "auto",
        }}
        className={className}
      />
    );
  }
  const strippedBody = stripQuotedContent(stripSupportTicketMessageMetadata(body));
  return (
    <div css={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }} className={className}>
      {strippedBody}
    </div>
  );
};
